import type { SrpRequestParams } from "@/providers/SRP/types";
import type { ZodSchema } from "zod";
import { PART_API_PATH } from "../../constants";
import useSRP from "../useSRP";

/**
 * Custom hook to fetch part data with optional schema validation
 *
 * @template T - The expected return type
 * @param {boolean} enabled - Flag to enable/disable the query
 * @param {SrpRequestParams} params - Request parameters
 * @param {ZodSchema<T>} [schema] - Optional Zod schema for response validation
 * @param {string} [baseURL] - Optional base URL for the API request
 * @returns {UseQueryResult<T>} Query result containing the fetched data
 * @throws {Error} When used outside of SrpApiContext
 */
export default function usePart<T>(
	enabled: boolean,
	params: SrpRequestParams,
	schema?: ZodSchema<T>,
	baseURL?: string,
) {
	return useSRP(PART_API_PATH, enabled, params, schema, baseURL);
}
